import React from 'react'
import Link from 'next/link'
import Image from 'next/image';
import {Card, Col, Container, Row,} from 'reactstrap'
import data from '../../data/camper_trips.json'
import {getImageUrl} from "../../services/image";

const PopularCities = props => {
  return (
      <section className={`py-3 bg-gray-100`}>
        <Container fluid>
          <Row className="">
            <Col xl="10" lg="10" className="mx-auto">
              <Row className="mb-5">
                <Col md="12">
                  <p className="subtitle text-primary">Laat je inspireren</p>
                  <h2>Geniet van de beste routes in Groot-Brittannië en Ierland</h2>
                </Col>
              </Row>
              <Row>
                {data.cities && data.cities.map((city, index) =>
                    <Col key={index} lg={city.width}
                         className="d-flex align-items-lg-stretch mb-4 block-item">
                      <Card
                          className="shadow-lg border-0 w-100 border-0 hover-animate"
                      >
                        <Link href={city.link}><a
                            className="tile-link text-shadow text-uppercase">{city.title}</a>
                        </Link>
                        <div
                            className="d-flex align-items-center h-100 text-white justify-content-center py-6 py-lg-7 inspirational-item">
                          <Image
                              src={getImageUrl(city.img)}
                              layout="fill"
                              objectFit="cover"
                              className="card"
                          />
                        </div>
                      </Card>
                    </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
  )
}

export default PopularCities;
